import { token, element, typography } from "@universityofmaryland/web-styles-library";
import { jssToCSS } from "@universityofmaryland/web-utilities-library/styles";
import "../elements/blocks.js";
import "../elements/full-screen.js";
import { createCompositeCarouselOverlay } from "../elements/overlay.js";
import { createCompositeCarouselImage } from "../elements/image.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import { createAnimationIndicator } from "../../../atomic/animations/actions/indicator.js";
import "../../../atomic/animations/brand/chevron-scroll.js";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import { fullscreen } from "../../../atomic/buttons/fullscreen.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/overlay/modal.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "../../../atomic/text-lockup/date.js";
import "../../../atomic/text-lockup/small.js";
import { layoutImage } from "../../../layout/image.js";
const MEDIUM = 500;
const ATTRIBUTE_REFERENCE = "data-reference";
const ATTRIBUTE_THEME = "data-theme";
const THEME_DARK = "dark";
const IS_THEME_DARK = `[${ATTRIBUTE_THEME}="${THEME_DARK}"]`;
const ELEMENT_NAME = "umd-carousel-image-standard";
const ELEMENT_CAROUSEL_IMAGE_DECLARATION = "carousel-image-standard-declaration";
const ELEMENT_CAROUSEL_IMAGE_CONTAINER = "carousel-image-standard-container";
const ELEMENT_SLIDE = "carousel-image-standard-slide";
const ELEMENT_SLIDE_IMAGE_CONTAINER = "carousel-image-standard-slide-image";
const ELEMENT_SLIDE_IMAGE_WRAPPER = "carousel-image-standard-slide-wrapper";
const ELEMENT_SLIDE_TEXT_CONTAINER = "carousel-image-standard-slide-text";
const ELEMENT_SLIDE_HEADLINE = "carousel-image-standard-slide-headline";
const ELEMENT_SLIDE_RICH_TEXT = "carousel-image-standard-slide-rich-text";
const ELEMENT_CAROUSEL_SLIDER_BUTTON = "carousel-slider-button";
const ELEMENT_CAROUSEL_INDICATOR_WRAPPER = "carousel-indicator-wrapper";
const ELEMENT_CAROUSEL_OVERLAY_IMAGE_COINTAINER = "carousel-overlay-image-container";
const OVERWRITE_THEME_DARK_CONTAINER = `.${ELEMENT_CAROUSEL_IMAGE_CONTAINER}${IS_THEME_DARK}`;
const OVERWRITE_THEME_DARK_RICH_TEXT = `${OVERWRITE_THEME_DARK_CONTAINER} .${ELEMENT_SLIDE_RICH_TEXT}`;
const OVERWRITE_THEME_DARK_TEXT_CONTAINER = `.${ELEMENT_CAROUSEL_IMAGE_CONTAINER}${IS_THEME_DARK} .${ELEMENT_SLIDE_TEXT_CONTAINER}`;
const OVERWRITE_THEME_DARK_IMAGE_CONTAINER = `.${ELEMENT_CAROUSEL_IMAGE_CONTAINER}${IS_THEME_DARK} .${ELEMENT_SLIDE_IMAGE_CONTAINER}`;
const OVERWRITE_THEME_DARK_INDICATOR = `.${ELEMENT_CAROUSEL_IMAGE_CONTAINER}${IS_THEME_DARK} .${ELEMENT_CAROUSEL_INDICATOR_WRAPPER}`;
const OVERWRITE_THEME_DARK_BUTTON = `.${ELEMENT_CAROUSEL_IMAGE_CONTAINER}${IS_THEME_DARK} .${ELEMENT_CAROUSEL_SLIDER_BUTTON}`;
const OverwriteThemeDark = `
  ${OVERWRITE_THEME_DARK_CONTAINER},
  ${OVERWRITE_THEME_DARK_TEXT_CONTAINER},
  ${OVERWRITE_THEME_DARK_INDICATOR} {
    background-color: ${token.color.black};
  }

  ${OVERWRITE_THEME_DARK_IMAGE_CONTAINER} {
    background-color: ${token.color.gray.dark};
  }

  ${OVERWRITE_THEME_DARK_TEXT_CONTAINER} * {
    color: ${token.color.white};
  }

  ${OVERWRITE_THEME_DARK_BUTTON} {
    background-color: ${token.color.black};
  }

  ${OVERWRITE_THEME_DARK_BUTTON} > svg {
    fill: ${token.color.white};
  }

  ${OVERWRITE_THEME_DARK_RICH_TEXT} {
    color: ${token.color.white};
  }

  ${jssToCSS({
  styleObj: {
    [`${OVERWRITE_THEME_DARK_RICH_TEXT}`]: element.text.rich.advancedDark
  }
})}
`;
const IndicatorContainerStyles = `
  .${ELEMENT_CAROUSEL_INDICATOR_WRAPPER} {
    padding: ${token.spacing.md};
    background-color: ${token.color.gray.lightest};
    display: flex;
    justify-content: center;
  }
  
  @container ${ELEMENT_NAME} (min-width: ${MEDIUM}px) {
    .${ELEMENT_CAROUSEL_INDICATOR_WRAPPER} {
      padding: ${token.spacing.lg};
    }
  }
`;
const OverlayImageContainerStyles = `
  .${ELEMENT_CAROUSEL_OVERLAY_IMAGE_COINTAINER} {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${token.color.gray.dark};
  }

  .${ELEMENT_CAROUSEL_OVERLAY_IMAGE_COINTAINER} img {
    object-fit: contain;
    max-height: 100%;
  }
`;
const TextContainerStyles = `
  .${ELEMENT_SLIDE_TEXT_CONTAINER} {
    padding: ${token.spacing.md};
    padding-bottom: 0;
    background-color: ${token.color.gray.lightest};
  }

  @container ${ELEMENT_NAME} (min-width: ${MEDIUM}px) {
    .${ELEMENT_SLIDE_TEXT_CONTAINER} {
      padding: ${token.spacing.lg};
      padding-bottom: 0;
    }
  }

  ${jssToCSS({
  styleObj: {
    [`.${ELEMENT_SLIDE_HEADLINE}`]: typography.sans.large
  }
})}

  .${ELEMENT_SLIDE_RICH_TEXT} {
    margin-top: ${token.spacing.min};
    color: ${token.color.gray.dark}
  }

  ${jssToCSS({
  styleObj: {
    [`.${ELEMENT_SLIDE_RICH_TEXT}`]: element.text.rich.advanced
  }
})}
`;
const ImageContainerStyles = `
  .${ELEMENT_SLIDE_IMAGE_CONTAINER} {
    position: relative;
    background-color: ${token.color.black};
  }

  .${ELEMENT_SLIDE_IMAGE_WRAPPER} {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .${ELEMENT_SLIDE_IMAGE_WRAPPER} > * {
    height: 100%;
  }

  .${ELEMENT_SLIDE_IMAGE_CONTAINER} img {
    object-fit: contain;
    max-height: 100%;
  }
`;
const STYLES_CAROUSEL_IMAGE_STANDARD_ELEMENT = `
  .${ELEMENT_CAROUSEL_IMAGE_DECLARATION} {
    container: ${ELEMENT_NAME} / inline-size;
  }

  .${ELEMENT_CAROUSEL_IMAGE_CONTAINER} {
    overflow: hidden;
    background-color: ${token.color.gray.lightest};
  }

  ${layoutImage.Styles}
  ${ImageContainerStyles}
  ${TextContainerStyles}
  ${OverlayImageContainerStyles}
  ${IndicatorContainerStyles}
  ${OverwriteThemeDark}
`;
const createCompositeCarouselImageStandard = (props) => (() => {
  const { images, isThemeDark, isFullScreenOption } = props;
  const elementDeclaration = document.createElement("div");
  const elementContainer = document.createElement("div");
  const elementIndicator = document.createElement("div");
  const overlayCarousel = createCompositeCarouselOverlay({
    images
  });
  let styles = STYLES_CAROUSEL_IMAGE_STANDARD_ELEMENT;
  styles += overlayCarousel.styles;
  const CreateTextContainer = ({
    headlines,
    texts,
    reference
  }) => {
    const textContainer = document.createElement("div");
    const headline = headlines?.find(
      (headline2) => headline2.getAttribute(ATTRIBUTE_REFERENCE) === reference
    );
    const richText = texts?.find(
      (text) => text.getAttribute(ATTRIBUTE_REFERENCE) === reference
    );
    textContainer.classList.add(ELEMENT_SLIDE_TEXT_CONTAINER);
    if (headline || richText) {
      if (headline) {
        headline.classList.add(ELEMENT_SLIDE_HEADLINE);
        textContainer.appendChild(headline);
      }
      if (richText) {
        richText.classList.add(ELEMENT_SLIDE_RICH_TEXT);
        textContainer.appendChild(richText);
      }
      return textContainer;
    }
    return null;
  };
  const CreateImageContainer = ({
    image,
    isFullScreenOption: isFullScreenOption2,
    setFullScreen,
    index: index$1
  }) => {
    const imageContainer = document.createElement("div");
    const imageWrapper = document.createElement("div");
    const imageBlock = layoutImage.CreateElement({
      image,
      showCaption: true
    });
    imageContainer.classList.add(ELEMENT_SLIDE_IMAGE_CONTAINER);
    imageWrapper.classList.add(ELEMENT_SLIDE_IMAGE_WRAPPER);
    imageWrapper.appendChild(imageBlock);
    if (isFullScreenOption2) {
      const button = fullscreen.create({
        callback: setFullScreen,
        index: index$1
      });
      imageBlock.appendChild(button.element);
      styles += button.styles;
    }
    imageContainer.appendChild(imageWrapper);
    return imageContainer;
  };
  const CreateSlide = (props2) => {
    const { images: images2, setFullScreen } = props2;
    const clonedImages = images2.map(
      (image) => image.cloneNode(true)
    );
    return clonedImages.map((image, index) => {
      const reference = image.getAttribute(ATTRIBUTE_REFERENCE);
      const slide = document.createElement("div");
      const imageContainer = CreateImageContainer({
        ...props2,
        image,
        setFullScreen,
        index
      });
      const textContainer = CreateTextContainer({ ...props2, reference });
      slide.classList.add(ELEMENT_SLIDE);
      slide.appendChild(imageContainer);
      if (textContainer) slide.appendChild(textContainer);
      return slide;
    });
  };
  const slides = CreateSlide({
    ...props,
    setFullScreen: overlayCarousel.events.setFullScreen
  });
  const carousel = createCompositeCarouselImage({
    slides,
    callback: (activeIndex) => {
      indicator.position(activeIndex);
    },
    maxHeight: 500
  });
  styles += carousel.styles;
  const indicator = createAnimationIndicator({
    count: images.length || 0,
    callback: carousel.events.EventMoveTo,
    isThemeDark,
    ...!isThemeDark && {
      overlayColor: token.color.gray.lightest
    }
  });
  styles += indicator.styles;
  elementIndicator.classList.add(ELEMENT_CAROUSEL_INDICATOR_WRAPPER);
  elementIndicator.appendChild(indicator.element);
  elementContainer.classList.add(ELEMENT_CAROUSEL_IMAGE_CONTAINER);
  elementContainer.appendChild(carousel.element);
  elementContainer.appendChild(elementIndicator);
  if (isThemeDark) elementContainer.setAttribute(ATTRIBUTE_THEME, THEME_DARK);
  elementDeclaration.classList.add(ELEMENT_CAROUSEL_IMAGE_DECLARATION);
  elementDeclaration.appendChild(elementContainer);
  images[images.length - 1].addEventListener("load", carousel.events.Load);
  const responseOptions = {
    styles,
    events: {
      SetEventReize: carousel.events.EventResize
    }
  };
  if (isFullScreenOption) {
    const element2 = document.createElement("div");
    element2.appendChild(overlayCarousel.element);
    element2.appendChild(elementDeclaration);
    return {
      element: element2,
      ...responseOptions
    };
  }
  return {
    element: elementDeclaration,
    ...responseOptions
  };
})();
export {
  createCompositeCarouselImageStandard
};
//# sourceMappingURL=standard.js.map
